import { createContext } from 'react';

import { ClientAddressCollection } from '../../../../types/api/clientAddress';
import { ClientSubsidiaryCollection } from '../../../../types/api/clients';
import { LabelValue } from '../../../../types/options';
import { Action } from './CreateEditRecreate.functions';

type Context = {
  sender: {
    isPlacesDataLoading: boolean;
    placesOptions: LabelValue[];
    isStreetsDataLoading: boolean;
    streetOptions: LabelValue[];
    isContactDataLoading: boolean;
    contactData: ClientAddressCollection | undefined;
    reloadContactData: () => void;
    subsidiaries: ClientSubsidiaryCollection | undefined;
    hubOptions: LabelValue[];
  };
  recipient: {
    isPlacesDataLoading: boolean;
    placesOptions: LabelValue[];
    isStreetsDataLoading: boolean;
    streetOptions: LabelValue[];
    isContactDataLoading: boolean;
    contactData: ClientAddressCollection | undefined;
    reloadContactData: () => void;
    subsidiaries: ClientSubsidiaryCollection | undefined;
    hubOptions: LabelValue[];
  };
  orderSettings: {
    action: Action;
    relatedOrderOptions: LabelValue[];
    specialProductOptions: LabelValue[];
    returnDocumentOptionsData: LabelValue[];
    letterTypeOptionsData: LabelValue[];
    isSpecialProductDataLoading: boolean;
    isReturnDocumentOptionsDataLoading: boolean;
    isletterTypeOptionsDataLoading: boolean;
    isRelatedOrderOptionsDataLoading: boolean;
    setFileForUpload: Function;
    file: File | undefined;
  };
  payments: {
    calculatorErrorMessage: string | undefined;
  };
};

const StepsContext = createContext<Context>({
  sender: {
    isPlacesDataLoading: false,
    placesOptions: [],
    isStreetsDataLoading: false,
    streetOptions: [],
    isContactDataLoading: false,
    contactData: undefined,
    reloadContactData: () => {},
    subsidiaries: undefined,
    hubOptions: [],
  },
  recipient: {
    isPlacesDataLoading: false,
    placesOptions: [],
    isStreetsDataLoading: false,
    streetOptions: [],
    isContactDataLoading: false,
    contactData: undefined,
    reloadContactData: () => {},
    subsidiaries: undefined,
    hubOptions: [],
  },
  orderSettings: {
    action: 'create',
    relatedOrderOptions: [],
    specialProductOptions: [],
    returnDocumentOptionsData: [],
    letterTypeOptionsData: [],
    isSpecialProductDataLoading: false,
    isReturnDocumentOptionsDataLoading: false,
    isletterTypeOptionsDataLoading: false,
    isRelatedOrderOptionsDataLoading: false,
    setFileForUpload: () => {},
    file: undefined,
  },
  payments: {
    calculatorErrorMessage: undefined,
  },
});

export default StepsContext;
